<template>
  <div class="all_stus_tutorial-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <template>
          <span
            v-for="(item, index) in tutorialTypes"
            :class="['tutorial-type', {'active' : tutorialTypes.indexOf(activeType) === index && tutorialTypes.length > 1} ]"
            :key="item.val"
            @click="switchType(item)"
          >{{item.text}}</span>
        </template>
      </yioks-page-nav>
      <div class="tutorial-content">
        <div class="content-header">
          <div class="sel-group-wrap">
            <select class="select level" v-model="calssLevelSelVal" @change="search">
              <option value>全部级别</option>
              <option
                v-for="item in classTrainLevelList"
                :value="item.value"
                :key="item.value"
              >{{item.key}}</option>
            </select>
            <select class="select date" v-model="dateSelVal" @change="search">
              <option value="">全部时间</option>
              <option v-for="item in dateSelList" :value="item.value" :key="item.value">{{item.key}}</option>
            </select>
            <select class="select type" v-model="typeSelVal" @change="search">
              <option v-for="item in typeSelList" :value="item.value" :key="item.value">{{item.key}}</option>
            </select>
          </div>
          <div class="search">
            <div class="wrap">
              <input class="search-input" v-model.lazy="keywords" placeholder="输入您想要查找的教案内容" type="text" @keyup.enter='search'>
              <div v-show="keywords!=''"
                class="close"
                @click="hideIcon">
                <v-icon name="regular/times-circle"
                  scale="1.2"></v-icon>
              </div>
            </div>
            <span class="search-btn" @click.stop='search'>搜索</span>
          </div>
        </div>
        <template v-show="!isEmpty">
          <div class="list-wrap">
            <yioks-loading v-show="isLoading"></yioks-loading>
            <div class="scroll-wrap" v-if="!isLoading">
              <vue-scroll :ops="vuescrollOpt" ref="vs">
                <div class="list-content">
                  <ul class="tutorials-wrap">
                    <li class="item" v-for="(item) in listData" :key="item.plan_id" @click="lookOverDetail(item.plan_id, item.user_id)">
                      <div class="up">
                        <div class="cover-wrap">
                          <img
                            :src="item.coverSrc"
                            @error="imgTutorialErr(item)"
                            alt=""
                          >
                          <tutorial-type :excellent="item.is_excellent"
                                         :type="item.session_type"></tutorial-type>
                          <tutorial-excellent v-if="Number(item.is_excellent) === 1"></tutorial-excellent>
                        </div>
                        <div class="title">
                          <p>{{item.title}}</p>
                          <div class="author">作者：{{item.user_name}}</div>
                        </div>
                      </div>
                      <div class="down">
                        <!-- <div class="author">作者：{{item.user_name}}</div> -->
                        <!-- <div class="updateTime">更新：{{item.last_updated | time}}</div> -->
                        <div class="club_name">{{item.class_name}}</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </vue-scroll>
            </div>
          </div>
          <div class="paging-wrap">
            <yioks-paging :paging="paging" @goto-page="gotoPage"></yioks-paging>
          </div>
        </template>
        <yioks-empty v-show="isEmpty" class="empty-box" h='auto'></yioks-empty>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { date, tutorial_types,classLevelList} from "@/assets/js/select";
import { stuTutorialList } from "@/api/common/api";
import { correctStatus } from "@/assets/js/apiStatus";
import defaultImg from "@/assets/images/plan_default.png";
import fiveMixins from '@/minix/fiveMixins';

export default {
  name: "AllStusTutorial",
  mixins: [fiveMixins],
  components: {
    "v-icon": Icon,
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "tutorial-type": () => import("@/components/Tutorial/tutorial-type"),
    "tutorial-excellent": () => import("@/components/Tutorial/tutorial-excellent"),
  },
  data() {
    const tutorialTypes = [
      {
        text: "学员教案",
        val: "stu",
        ajaxParam: ""
      },
      {
        text: "优秀教案",
        val: "excellent",
        ajaxParam: "Y"
      }
    ];
    return {
      // defaultImg,
      isLoading: true,
      isEmpty: false,
      dateSelList: date,
      typeSelList: tutorial_types,
      levelSelList: classLevelList,
      tutorialTypes,
      activeType: tutorialTypes[0],
      dateSelVal: "",
      calssLevelSelVal: "",
      typeSelVal: "",
      keywords: "",
      is_excellent: "",
      listData: [],
      thePage: 1,
      paging: {
        start: 0,
        prePage: 1, // 一页多少条数据
        total: 1, // 总页数
        size: 3, // 页码显示限制
        last: true, // 尾页
        next: true, // 下一页
        first: true, // 首页
        previous: true, // 上一页
        jump: true
      },
      vuescrollOpt: createScrollOpt()
    };
  },
  created() {
    this.setData();
    this.getTutorialList();
  },
  methods: {
    setData() {
      const {page, session_type, search_keywords, update_time, is_excellent,level} = this.$route.query;
      page && (this.thePage = page);
      session_type && (this.typeSelVal = session_type);
      search_keywords && (this.keywords = search_keywords);
      update_time && (this.dateSelVal = update_time);
      level && (this.calssLevelSelVal = level);
      is_excellent && (this.is_excellent = is_excellent);
      is_excellent && this.tutorialTypes.map((item)=>{
        if(item.ajaxParam === is_excellent) {
          this.activeType = item;
        }
      });
    },
    // 图片加载失败时，用一个默认图来替换😁
    imgTutorialErr(item) {
      const idx = this.listData.indexOf(item);
      if (idx === -1) return;
      this.listData.splice(idx,1,{...item, coverSrc: defaultImg})
    },
    // 从后台获取教案列表数据💢，同时改变分页相关的数据🚥
    getTutorialList() {
      this.isEmpty = false;
      this.isLoading = true;
      stuTutorialList({
        page: this.thePage,
        session_type: this.typeSelVal,
        search_keywords: this.keywords,
        update_time: this.dateSelVal,
        level: this.calssLevelSelVal,
        is_excellent: this.is_excellent,
      })
        .then(({ data }) => {
          this.isLoading = false;
          if (data.status === correctStatus) {
            const { list, page, plan_count, user_list } = data.result;
            this.listData = list.map(item => ({
              ...item,
              coverSrc: `/uploads/library/${item.drill_id}.jpg?v=${item.last_updated}`
            }));
            this.$set(this.paging, "prePage", page.page_size);
            this.$set(this.paging, "total", page.total_row);
            this.$set(this.paging, "start", (this.thePage - 1) * this.paging.prePage);
          }
          this.isEmpty = this.listData.length <= 0
        })
        .catch(err => {
          this.isLoading = false;
          console.error(err);
        });
    },
    /*dateSelChangeHandle() {
      this.changeQuery(true);
      this.getTutorialList()
    },
    typeSelChangeHandle() {
      this.changeQuery(true);
      this.getTutorialList()
    },
    searchHandler() {
      this.changeQuery(true);
      this.getTutorialList()
    },*/
    search() {
      this.changeQuery(true);
    },
    hideIcon() {
      this.keywords = "";
      this.changeQuery(true);
    },
    gotoPage(start) {
      this.thePage = parseInt(start / this.paging.prePage) + 1;
      this.changeQuery(false);
      this.$refs['vs'].scrollTo({ y: 0 });
    },
    // 这里要留一手，现在虽然没有这个功能，说不好马上就要改了 😂😂😂
    // 切换教案种类（优秀教案、我的教案等）。
    switchType(item) {
      if (item.val === this.activeType.val) return;
      this.activeType = item;
      this.is_excellent = item.ajaxParam;
      if (this.tutorialTypes.length <= 1) return;
      this.dateSelVal = "";
      this.typeSelVal = "";
      this.keywords = "";
      this.calssLevelSelVal = "";
      this.changeQuery(true);
    },
    changeQuery(flag) {
      flag && (this.thePage = 1);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: this.thePage,
          session_type: this.typeSelVal,
          search_keywords: this.keywords,
          update_time: this.dateSelVal,
          level: this.calssLevelSelVal,
          is_excellent: this.is_excellent,
        }
      });
      this.getTutorialList();
    },
    goBack() {
      /*this.$router.push({
        name: "TrainingCourseManager"
      });*/
      this.$router.go(-1);
    },
    lookOverDetail(plan_id, user_id) {
      // console.log(id);
      this.$router.push({
        path: "tutorial_detail",
        query: {
          id: plan_id,
          user_id: user_id
        }
      });
    }
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'

$right-box-space = 30px
.all_stus_tutorial-root
  zuxie-page-root()
  .main-content-wrap
    color $color_white
    font-size $font_size_medium
    .nav-wrap
      margin-bottom 25px
      .tutorial-type
        padding 5px 10px
        cursor pointer
        font-size 18px
        &+.tutorial-type
          margin-left 10px
        &.active
          padding 8px 15px
          color $color_white
          background-color $color_suc
    .tutorial-content
      position relative
      display flex
      flex-direction column
      width 100%
      height 610px
      padding-top 30px
      padding-bottom 20px
      background-color $block_bg_color_base
      .empty-box 
        position absolute 
        top: 50%;
        transform: translateY(-50%);
      .content-header
        display flex
        flex none
        justify-content space-between
        color $color_black
        font-size $font_size_medium
        height 34px
        padding-right $right-box-space
        padding-left $right-box-space
        margin-bottom 10px
        .sel-group-wrap
          display flex
          .select
            border 1px solid #999
            padding 0 10px
            outline 0
          .date
            width 140px
            margin-right 10px
          .type
            width 140px
          .level
            width 140px
            margin-right 10px
        .search
          display flex
          height 34px
          .wrap
            height:100%;
            position:relative;
            .search-input
              width 265px
              height: 100%
              padding 0 15px
              outline 0
            .close
              position: absolute;
              right: 5px;
              top: 8px;
              color: $color_info;
              cursor: pointer;
          .search-btn
            width 65px
            display flex
            align-items center
            justify-content center
            line-height 1
            background-color $color_suc
            color $color_white
            cursor pointer
      .list-wrap
        position relative
        // flex 1
        display block 
        height 481px 
        overflow hidden
        .scroll-wrap
          display block
          width 100%
          height 100%
          padding-top 10px
          padding-bottom 10px
          overflow hidden
          .list-content
            display block
            padding-left $right-box-space
            padding-right $right-box-space
            .tutorials-wrap
              display flex
              flex-wrap wrap
              justify-content space-between
              .item
                flex 0 0 auto
                width 405px
                height 170px
                padding 15px 20px 0 20px
                margin 0 0 30px 0
                font-size $font_size_big
                background-color $block_bg_color_base
                cursor pointer
                .up
                  display flex
                  padding 0 0 15px 0
                  border-bottom 1px solid $color_white
                  .cover-wrap
                    flex 0 0 auto
                    position relative
                    width 170px
                    height 100px
                    img 
                      display block 
                      width 100%
                      height 100% 
                  .title
                    height 100px
                    padding 0 0 0 10px
                    overflow hidden
                    p
                      display -webkit-box
                      -webkit-line-clamp 3
                      -webkit-box-orient vertical
                      overflow hidden
                      height 75px
                      margin-bottom 5px
                    .author
                      over_hide()
                      line-height 1
                .down
                  display flex
                  justify-content space-between
                  padding 10px 0 0
                  font-size: 14px
                  line-height 1
                  .club_name 
                    over_hide()
      .paging-wrap
        flex none
        padding-top 10px
</style>


